<nav class="nav fixed-top p-3 justify-content-center"
style="background-image: url('assets/img/h1_hero.png');
              background-repeat: no-repeat;
                background-attachment: fixed;
      background-position: center; 
       background-size: cover;
            "
            >
    <a class="nav-link" routerLink="/">Home</a>
    <a class="nav-link" routerLink="/aplikasi">Applikasi</a>
    <a class="nav-link" routerLink="/website">Website</a>
    <a class="nav-link" routerLink="/axcoraschool">ERP</a>
  </nav>

<div class="container">
<div class="row">
    <div class="col-12 col-md-12 p-3 p-md-5 text-center">
        <img src="assets/img/logo.png" alt="aplikasi Rapot Online"/><br/>    
    <img class="img-fluid rounded shadow" src="assets/img/aplikasi sekolah e-slearn online.jpg" alt="aplikasi belajar sekolah lengkap"/><br/>
    <h3 class="text-left"><strong><a href="https://axcoraschool.vercel.app">Aplikasi E-Learn Lengkap</a></strong></h3>
<p class="text-left">Untuk kesuksesan metode belajar mengajar modern maka aplikasi e-learning lengkap ini adalah prioritas utama untuk digunakan, dengan modern desain UI yang mudah digunakan tentunya dengan dukungan system software program yang lengkap menyempurnakan untuk sekolah menggunakan apps ini.</p>
 
<img class="img-fluid" src="assets/img/aplikasi belajar online sekolah e-learning.jpg" alt="aplikasi lengkap untuk belajar guru sekolah"/><br/>
<p class="text-left">Dengan installasi via online clouds langsung memudahkan dalam kebutuhan akses via berbagai perangkat device dalam bekerja baik via android iphone pc desktop laptop windows dan berbagai OS lain nya semakin memudahkan dan mobile dengan menggunakan apps ini.</p>
<img class="img-fluid rounded shadow" src="assets/img/aplikasi belajar sekolah online e-learning.jpg" alt="aplikasi belajar siswa murid sekolah lengkap"/><br/>
<p class="text-left">
Dengan dukungan fitur terbaik : Guru admin apps : home page, data kelas, data siswa , data ujian untuk memasukan soal ujian dilengkapi dengan pertanyaan dan pilihan jawaban untuk memudahkan siswa dalam menjawab soal pertanyaan ujian ulangan dan lain nya, hasil ujian konvert otomatis ketika siswa sudah melaksanakan dan menjawab hasil ujian nya, laporan ujian untuk cek laporan laporan ujian perkelas dan persiswa , pesan chat untuk menerima pesan dari siswa untuk kebutuhan interaksi dengan guru pengajar.
Siswa apps : Home page, chat pesan dengan guru pengajar, informasi tugas dan ujian soal , hasil ujian baik yang sudah dikerjakan dan belum dikerjakan, menjawab soal pertanyaan ujian real time dengan durasi waktu yang diberikan oleh guru pengajar, submit jawaban untuk menyelesaikan tugas, dan konvert hasil nilai otomatis setiap ujian soal dan tugas yang dikerjakan.
    <br/>
    <a href="https://youtu.be/_vg23sv_JVQ" target="_blank" class="text-danger">Demo guru →</a> /
    <a href="https://www.youtube.com/watch?v=VioIwalm0HM" target="_blank" class="text-danger">Demo siswa murid →</a>
</p>
<div class="row">
    <div class="col-6 col-md-6 p-3 p-md-5">
        <div class="border border-dark p-3 rounded">
<h3 class="bg-dark text-white p-3 text-center">Plugin website</h3>
<p>Plugin untuk paket website axcora school cms.</p>
<p class="border border-dark p-3 text-center"><strong>Rp.865.800</strong></p>
    </div></div>
    <div class="col-6 col-md-6 p-3 p-md-5">
        <div class="border border-danger p-3 rounded">
<h3 class="bg-danger text-white p-3 text-center">E-Learn Premium</h3>
<p>
    E-learn Premium Apps
, Free Domain .sch.id
, Web Space 1.5GB
, Include Host
, <a routerLink="/cms" class="text-danger">axcora school cms →</a>
, website sekolah
, APK Android Guru
, APK Android Siswa 
</p>
<p class="border border-danger p-3 text-center"><strong>Rp.2.712.300</strong></p>
<div class="text-center">
    <a href="https://wa.me/6285646104747?text=Axcoraschoolapps%20saya%20mau%20order%20Website%0ANama/Sekolah%20%3A%0AAlamat%20%3A%0APaketweb%20%3AAxcoraschoolcms+E-learnpremium%0APrice%20%3ARp.2.712.300/tahun%0APembayaran%20via%20%3A%0ABCA%208290363021%20Rica%20Anggraini%0A%0Atolong%20diproses%20pesanan%20saya" class="btn card-btn1">Order</a>
</div>
    </div></div>
</div>
<a routerLink="/website" class="btn btn-success rounded-pill btn-lg">Cek Paket website</a>
</div>


    </div></div>

  
    <div class="testimonial-area fix" >

    
    
        <div class="wantToWork-area ">
        <div class="container">
        <div class="wants-wrapper w-padding2 section-bg2" 
         style="background-image: url('assets/img/section_bg02.png');
                  background-repeat: no-repeat;
                    background-attachment: fixed;
          background-position: center; 
           background-size: cover;
                "
                >
        <div class="row align-items-center justify-content-center">
        <div class="col-xl-7 col-lg-9 col-md-8">
        <div class="wantToWork-caption text-center">
        <h2>ERP Sekolah</h2>
        <p>All in one system web app sekolah dalam satu applikasi super lengkap dalam kebutuhan proses belajar mengajar , e learning, absensi, hingga keuangan sekolah , agenda pengumuman berita sekolah include.
    <br/>
    Applikasi ERP sekolah dengan admin apps, guru pengajar apps, tata usaha dan keuangan apps, siswa murid apps, all in one integrasi dalam axcora school ERP untuk sekolah anda.
        </p>
        <a routerLink="/axcoraschool" class="btn3 wantToWork-btn">Pelajari ERP Sekolah</a><br/><br/><br/><br/>
        </div>
        </div>
        </div>
        </div>
        </div>
        </div>
        
      </div>
